export default {
  element: {
    LINK: 'Link',
    USER_LINK: 'UserLink',
    AVATAR: 'Avatar',
    VOTE: 'Vote',
    FOLLOW: 'Follow',
    FACEBOOK: 'Facebook',
    EMAIL: 'Email',
    LOGIN: 'Login',
    LIKE: 'Like',
    SIGNUP: 'Signup',
    WRITE: 'Write',
    EDIT: 'Edit',
    REPLY: 'Reply',
    REPLY_HIDDEN_LINK: 'ReplyHiddenLink',
    REPLY_SUBMIT: 'SubmitReply',
    BUTTON: 'Button',
    UNTRACKED: 'UNTRACKED',
    FIND_OTHERS_LINK: 'FindOthersLink',
    TAKE_HEALTH_NEEDS_QUIZ_LINK: 'TakeHealthNeedsQuizLink',
    ASK_HEALTH_QUESTION_LINK: 'AskHealthQuestionLink',
    PROMO_IMAGE: 'PromoImage',
    ENROLL_PROGRAM: 'EnrollProgram',
    PROGRAM_SECTION_MARK_AS_COMPLETE: 'ProgramSectionMarkAsComplete',
    PROGRAM_SECTION_TOGGLE_SECTION: 'ProgramSectionToggleSection',
    PROGRAM_MODULE_PREVIOUS_LINK: 'ProgramModulePreviousLink',
    PROGRAM_MODULE_NEXT_LINK: 'ProgramModuleNextLink',
  },
  section: {
    HEADER: 'Header',
    ABOVE_FOOTER: 'AboveFooter',
    DISCOVER: 'DiscoverHealth',
    CONVERSION: 'ConvBox',
    CONVERSION_UPPER: 'ConvBoxUpper',
    CONVERSION_LOWER: 'ConvBoxLower',
    CONVERSION_SIDEBAR: 'ConvBoxSidebar',
    CONVERSION_HIDDEN_RESP: 'ConvBoxReply',
    LOGIN_REDIRECT: 'LoginBox',
    BANNER: 'Banner',
    POST: 'Post',
    POSTS: 'Posts',
    REPLY: 'Reply',
    POST_REPLY: 'PostReply',
    POLL: 'Poll',
    POLLS: 'Polls',
    POLL_REPLY: 'PollReply',
    MOBILE_NAV: 'MobileNav',
    SEARCH_HIT: 'SearchHit',
    USER_LIST: 'UserList',
    RELATED_WIDGET: 'RelatedCommunity',
    COMMUNITY: 'Community',
    COMMUNITY_HOME_MEMBERS: 'CommunityHomeMembers',
    COMMUNITY_HOME_POST: 'CommunityHomePost',
    COMMUNITY_HOME_POLL: 'CommunityHomePoll',
    COMMUNITY_ABOUT: 'CommunityAbout',
    COMMUNITY_BOX: 'CommunityBox',
    COMMUNITY_MEMBERS: 'CommunityMembers',
    SIGNUP_PAGE: 'SignupPage',
    FLOATING_BOX: 'FloatingBox',
    VISITOR_MENU: 'VisitorMenu',
    TAGS_PAGE_SIDEBAR: 'TagsPageSidebar',
    PROGRAM_OVERVIEW: 'ProgramOverview',
    PROGRAM_MODULE_SECTION: 'ProgramModuleSection',
    UNTRACKED: 'UNTRACKED',
  },
};



// WEBPACK FOOTER //
// ./src/constants/signupContext.js